// PALBON Docs: the user manual's reader (templates/palbonsphere_docs.html). The server renders the article and the
// navigation data (#pd-data, palbon_docs/docs_nav.py); this app builds the full-width reader around them.
import { createApp } from "vue";
import DocsApp from "./docs/DocsApp.vue";

function mount() {
	const host = document.getElementById("pd-app");
	const data = document.getElementById("pd-data");
	const article = document.getElementById("pd-article");
	if (!host || !data || !article) return;
	let docs = {};
	try {
		docs = JSON.parse(data.textContent || "{}");
	} catch (error) {
		return; // the server-rendered page stays as it is
	}
	if (!Array.isArray(docs.tree)) return;
	createApp(DocsApp, { docs, article }).mount(host);
	document.documentElement.classList.add("pd-ready");
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mount);
else mount();
